import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/cloud-new/cloud_platforms_back.webp";

function Cloudplatformslaverage() {
  return (
    <section
      className="cloud_platforms_laverage p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Cloud Platforms We Leverage</h2>
            <p>
              We power your cloud enablement program with the world’s top
              technologies for high-end deployment, fail-safe functioning, and
              zero downtime across all respective business units.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={11} xxl={10} className="m-auto">
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="cloud_platform_box">
                  <div className="cloud_platform_img">
                    <StaticImage
                      src="../../images/services-usa/cloud-new/aws_cloud.webp"
                      alt="AWS"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={130}
                      height={78}
                    />
                  </div>
                  <div className="cloud_platform_content">
                    <h5>AWS</h5>
                    <p>
                      Optimize your cloud strategy with AWS, ensuring scalable
                      and high-performance solutions for your business units,
                      guided by our expert cloud consulting services.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="cloud_platform_box">
                  <div className="cloud_platform_img">
                    <StaticImage
                      src="../../images/services-usa/cloud-new/azure_cloud.webp"
                      alt="Azure"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={141}
                      height={77}
                    />
                  </div>
                  <div className="cloud_platform_content">
                    <h5>Azure</h5>
                    <p>
                      Access advanced cloud capabilities with Azure to boost
                      innovation and efficiency across your organization,
                      supported by our experienced cloud consulting company.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="cloud_platform_box">
                  <div className="cloud_platform_img">
                    <StaticImage
                      src="../../images/services-usa/cloud-new/google_cloud.webp"
                      alt="Google Cloud"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={101}
                      height={80}
                    />
                  </div>
                  <div className="cloud_platform_content">
                    <h5>Google Cloud</h5>
                    <p>
                      Deploy Google Cloud for agile and reliable deployments for
                      minimized downtime and maximized productivity with our
                      tailored cloud consulting services.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudplatformslaverage;
